"use client"

import { useState } from "react"
import { CheckCircle, ArrowRight } from "lucide-react"
import "./TrialStartedModal.css"

export default function TrialStartedModal({ show, startDate, endDate, onGetStarted }) {
  const [isLoading, setIsLoading] = useState(false)

  const handleGetStarted = async () => {
    setIsLoading(true)
    try {
      await onGetStarted()
    } finally {
      setIsLoading(false)
    }
  }

  if (!show) return null

  // Format dates for display
  const formatDate = (date) => {
    if (!date) return ""
    return new Date(date).toLocaleString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
    })
  }

  return (
    <div className="trial-started-overlay">
      <div className="trial-started-container">
        {/* Icon Section */}
        <div className="trial-started-icon-wrapper">
          <div className="trial-started-icon">
            <CheckCircle size={48} />
          </div>
        </div>

        {/* Content Section */}
        <div className="trial-started-content">
          <h2 className="trial-started-title">Your Free Trial Has Started</h2>

          <div className="trial-started-message">
            <p>
              Your free trial has been activated. Explore all the premium features at no cost during your trial period.
            </p>
          </div>

          {/* Trial Period Info */}
          <div className="trial-started-trial-info">
            <div className="trial-started-info-row">
              <span className="trial-started-info-label">Start Date:</span>
              <span className="trial-started-info-value">{formatDate(startDate)}</span>
            </div>
            <div className="trial-started-info-row">
              <span className="trial-started-info-label">End Date:</span>
              <span className="trial-started-info-value">{formatDate(endDate)}</span>
            </div>
          </div>

          {/* Features List */}
          <div className="trial-started-features">
            <div className="trial-started-feature-item">
              <span>
                <strong>What's included:</strong>
              </span>
            </div>
            <div className="trial-started-feature-item">
              <span className="trial-started-check">✓</span>
              <span>Complete feature access</span>
            </div>
            <div className="trial-started-feature-item">
              <span className="trial-started-check">✓</span>
              <span>Advanced analytics & reporting</span>
            </div>
            <div className="trial-started-feature-item">
              <span className="trial-started-check">✓</span>
              <span>Full team collaboration tools</span>
            </div>
          </div>
        </div>

        {/* Action Button */}
        <button
          className={`trial-started-button ${isLoading ? "loading" : ""}`}
          onClick={handleGetStarted}
          disabled={isLoading}
        >
          <span className="trial-started-button-text">{isLoading ? "Starting..." : "Get Started"}</span>
          {!isLoading && <ArrowRight size={20} />}
        </button>
      </div>
    </div>
  )
}
